<template>
  <div class="container page record-page">
    <div class="header">
      <van-nav-bar :title="$t('foorter.ti_record')" class="nav-bar page-nav">
        <template #left>
          <van-icon name="arrow-left" class="nav-back" @click="back()"/>
        </template>
      </van-nav-bar>
    </div>
    <div class="main">
      <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
          <van-empty v-if="list.length === 0" :description="$t('withdraw.empty_data')" />
          <div v-else class="item_list" v-for="(v,key) in list" :key="key">
            <div class="topInfo">
              <span v-if="v.status === 3" class="status-success">{{$t('foorter.top30')}}</span>
              <span v-else-if="v.status === 2" class="status-success">{{$t('foorter.top29')}}</span>
              <span v-else >{{$t('foorter.top28')}}</span>
              <span>{{$t("reservation.unit")}}:+{{v.money}}</span>
            </div>
            <div class="desc" v-if="v.status === 3"> 
              <span>{{$t("withdraw.desc")}}:{{v.desc}}</span>
            </div>
			<div class="desc">
              <span>{{$t("foorter.top35")}}:<span v-if="v.type==1" style="color:red">{{$t("foorter.top36")}}</span><span v-if="v.type==2" style="color:red">{{$t("foorter.top37")}}</span></span>
            </div>
<div class="desc">
<span v-if="v.c_type==1" style="color:red">{{$t("auth.top43")}}</span>
<span v-else style="color:red">
	<span v-if="v.types==1" style="color:red">{{$t("my.msg50")}}</span>
	<span v-if="v.types==2" style="color:red">{{$t("my.msg51")}}</span>
</span>
</div>
            <div class="time">
              <span>{{$t("withdraw.submit_time")}}：{{v.create_time}}</span>
            </div>
            <div class="time">
              <span>{{$t("withdraw.check_time")}}：{{v.update_time}}</span>
            </div>
          </div>
      </van-pull-refresh>
    </div>
  </div>

</template>

<script>
export default {
  data() {
    return {
      isLoading: false,
      list:[]
    };
  },
  methods: {
    back(){
      return window.history.back();
    },
    onRefresh() {
      setTimeout(() => {
        this.$toast(this.$t("reservation.refresh"));
        this.isLoading = false;
      }, 500);
    },
    getUserWithdrawList(){
      this.$http({
        method: 'get',
        url: 'user_get_ti_list'
      }).then(res=>{
        if(res.code === 200){
          this.list = res.data;
        }else if(res.code ===401){
          this.$toast(res.msg);
        }
      })
    }
  },
  created() {
    if(!localStorage.getItem('token')){
      this.$router.push({path:'/Login'})
    }else {
      this.getUserWithdrawList();
    }
  }
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.css";
.record-page {
  min-height: 100%;
  background: #f5f5f5;
}

::v-deep .van-pull-refresh__track .van-pull-refresh__head *{
  color: #000000;
  font-size: 35px;
}

::v-deep .van-loading__text {
  color: #000000;
  font-size: 35px;
}
.container .main{
  position: relative;
  overflow: auto;
  background-color: #f5f5f5;
  height: 100%;
  padding: 10px 12px 24px;
}

.item_list{
  padding: 20px 20px;
  margin: 0 0 18px;
  background: #fff;
  border-radius: 16px;
  line-height: 60px;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.05);
}

.topInfo {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.item_list .topInfo span{
  flex: 1;
  font-size: 35px;
  font-weight: 700;
  color: #ff253f;
}

.item_list .topInfo .status-success {
  color: #07c160;
}

.item_list .time span{
  flex: 1;
  font-size: 25px;
  font-weight: 500;
  color: #000;
}

.item_list .topInfo span:last-child{
  float: right;
}
.item_list .desc span{
  font-size: 25px;
  font-weight: 700;
  color: #9b9b9b;
}

.nav-back {
  color: #8795ad;
}

::v-deep .page-nav {
  background: #fff;
}

::v-deep .page-nav .van-nav-bar__title {
  color: #000;
}

::v-deep .page-nav::after {
  border-bottom: 1px solid #ededed;
}

</style>
